import React from 'react';
import PropTypes from 'prop-types';
import Markdown from '../../components/Markdown';
import Page from '../../components/Page.js';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import policyStyle from './components/policyStyle';

const useStyles = makeStyles(policyStyle);

const TermsPage = ({content}) => {
  const classes = useStyles();
  if (!content) return null;
  return (
    <Page title={content.title}>
      <Container className={classes.container} fixed disableGutters={true} maxWidth="md">
        <Typography variant="h1" color="primary">{content.title}</Typography>
        <Markdown content={content.body}/>
      </Container>
    </Page>
  );

};

TermsPage.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  })
};

export default TermsPage;
